module.exports = __webpack_public_path__ + "img/Screenshot 2021-06-04 at 18-46-24 Obstacle Courses – A M Amusements.89f04d25.png";